import { useCallback } from 'react';
import { useSettingsStore, JumpType, PlaybackEventEmitter, PlaybackEvent, } from '@annunciate/core';
import { usePlaying } from './usePlaying';
const JUMP_INTERVALS = {
    10: 15,
    15: 20,
    20: 25,
    25: 30,
    30: 40,
    40: 50,
    50: 60,
    60: 10,
};
const { setJumpForward, setJumpBackward } = useSettingsStore.getState();
export const useJump = () => {
    const { playing } = usePlaying();
    const jumpForward = useSettingsStore(state => state.jumpForward);
    const jumpBackward = useSettingsStore(state => state.jumpBackward);
    const jump = useCallback(async (mode = JumpType.FORWARD) => {
        if (!playing)
            return;
        if (mode === JumpType.FORWARD) {
            PlaybackEventEmitter.emit(PlaybackEvent.JUMP_FORWARD, jumpForward);
        }
        else {
            PlaybackEventEmitter.emit(PlaybackEvent.JUMP_BACKWARD, jumpBackward);
        }
    }, [
        playing?.id,
        jumpForward,
        jumpBackward,
    ]);
    const nextJumpForward = useCallback(() => {
        setJumpForward(JUMP_INTERVALS[jumpForward]);
    }, [
        jumpForward,
    ]);
    const nextJumpBackward = useCallback(() => {
        setJumpBackward(JUMP_INTERVALS[jumpBackward]);
    }, [
        jumpBackward,
    ]);
    return {
        jump,
        jumpForward,
        jumpBackward,
        setJumpForward,
        setJumpBackward,
        nextJumpForward,
        nextJumpBackward,
    };
};
//# sourceMappingURL=useJump.js.map